import React from "react"
import { useSelector } from "react-redux"

import HeaderCellGroup from "../cells/HeaderCellGroup"
import HeaderCell from "../cells/HeaderCell"
import { retrieveSpecificWorkQ } from "../../../lib/systemData"
import { getWorkQGroupedFieldsForUser } from "../../../lib/workQ"

function WorkQHeader({slug}) {
    const editPermissions = useSelector((state) => state.permissions.editPermissions)

    const isVisibleInTable = React.useCallback((item) => {
        if (item?.show_in_table === undefined || item?.show_in_table === null) {
            return true
        }

        return item.show_in_table === 1 || item.show_in_table === true || item.show_in_table === '1'
    }, [])
    // Removed useEffect. Use useMemo to compute filteredData directly based on slug and filters.
    const filteredData = React.useMemo(() => {
        const workq = retrieveSpecificWorkQ(slug)
        if (workq && workq.grouped_fields) {
            return getWorkQGroupedFieldsForUser(workq, editPermissions)
        }
        return null
    }, [slug, editPermissions])

    // old code
    // const [filteredData, setFilteredData] = useState(null)
    // // const [showMasterId, setShowMasterId] = useState(false)

    // useEffect(() => {

    //     const workq = retrieveSpecificWorkQ(slug)
    //     if (workq && workq.grouped_fields) {
    //         setFilteredData(workq.grouped_fields)
    //     }
        
    // }, [slug, filters]) 

    const getGreyShade = React.useCallback((index) => {
        let greyShades = ["rgb(175 220 231)"]
        if (slug == "verifications-q") {
            greyShades = ["var(--primary-10-solid)"]
        }
        return greyShades[index % greyShades.length]
    }, [slug])

    const filteredDataWithBg = React.useMemo(() => {
        if (!filteredData) return null
        return filteredData.map((group, idx) => ({
            ...group,
            bgColor: getGreyShade(idx)
        }))
    }, [filteredData, getGreyShade]);

    const headerRows = React.useMemo(() => {
        if (!filteredDataWithBg) return null
        return filteredDataWithBg.map((group) => {
            const visibleItems = group.items
                .filter(elem => elem.type !== 'hover' && isVisibleInTable(elem))
            return {
                ...group,
                visibleItems,
                colSpan: visibleItems.length,
            }
        })
    }, [filteredDataWithBg, isVisibleInTable])


    return <>
        <tr>
{/* && showMasterId */}
            {headerRows && headerRows.map(item => (   
                <th style={{backgroundColor: item.bgColor}} key={item.groupName} className={`table-cell-fit table-cell-last table-cell-header-main`} colSpan={item.colSpan}>
                    <HeaderCellGroup item={item}/> 
                </th>
                // <th key={item.groupName} className={`table-cell-fit`} colSpan={item.items.filter(elem => elem.type !== 'hover').length}>
                //     <HeaderCellGroup item={item}/> 
                // </th>
            ))}
        </tr>
        <tr>

            {headerRows && headerRows.map((item, index) => (
                <React.Fragment key={item.groupName + index}>
                    {item.visibleItems.map((sub_item, sub_item_index) => ( //remove the hover type!
                        <th  key={sub_item.label + sub_item.type} className={`table-cell-fit ${sub_item_index == item.visibleItems.length - 1 && 'table-cell-last'}`}>
                            <HeaderCell item={sub_item}/>
                        </th>
                    ))}
                </React.Fragment>
                
            ))}
        </tr>
    </>
}

export default React.memo(WorkQHeader)
